import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { initPage } from "@/common/constant/init-page";
import { PaginationSize } from "@/common/enum/pagination-size";
import { PartnerQuotePath } from "@/common/enum/path";
import { formatDateToDDAhmm } from "@/common/util/date-util";
import { quoteService } from "@/services/quote-service";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageDotOutlineIcon } from "../icon/MessageDotOutlineIcon";
import { Body14Medium } from "../typography/Body14Medium";
import { Body14Regular } from "../typography/Body14Regular";

export const PartnerQuoteProgressSimplePanel = () => {
  const [page, setPage] = useState<BasePageDto<QuoteDetailDto>>(initPage);

  const getPage = async () => {
    try {
      const response = await quoteService.getPage({
        page: page.currentPage,
        size: PaginationSize.SIZE_10,
      });
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      setPage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPage();
  }, []);

  // 현재 날짜로부터 30일 이내의 데이터 필터링 및 최대 2개로 제한
  const recentData = page.contents
    .filter((item) => moment().diff(moment(item.createdAt), "days") <= 30)
    .slice(0, 2);

  return (
    <div className="flex flex-col rounded-[4px] border-[1px] border-semantic-divider bg-primary-white p-[24px] w-[708px] h-[208px]">
      {recentData.length > 0 ? (
        recentData.map((item) => (
          <Link
            key={item.id}
            to={PartnerQuotePath.QUOTES_DETAIL.replace(":id", String(item.id))}
          >
            <PartnerQuoteProgressItem item={item} />
          </Link>
        ))
      ) : (
        <PartnerQuoteProgressEmptyItem />
      )}
    </div>
  );
};

interface PartnerQuoteProgressItemProps {
  item: QuoteDetailDto;
}

const PartnerQuoteProgressItem: React.FC<PartnerQuoteProgressItemProps> = ({
  item,
}) => {
  return (
    <div className="flex justify-between py-[8px]">
      <div className="flex items-center gap-[8px]">
        <MessageDotOutlineIcon size={20} color="text-grayscale-contrast-40" />
        <Body14Regular className="text-semantic-text-body truncate max-w-[500px]">
          {item.constructionName}:{item.constructionWorkName}
        </Body14Regular>
      </div>
      <Body14Regular className="text-semantic-text-tertiary">
        {formatDateToDDAhmm(item.createdAt)}
      </Body14Regular>
    </div>
  );
};

const PartnerQuoteProgressEmptyItem = () => {
  return (
    <div className="flex h-[208px] items-center justify-center">
      <Body14Medium className="text-semantic-text-tertiary">
        저장된 견적서가 없습니다
      </Body14Medium>
    </div>
  );
};
